import React from 'react'

/**
 * Date picker component
 *
 * @param className
 * @param onChange
 * @param handleBlur
 * @param value
 * @param name
 * @param title
 * @returns {JSX.Element}
 * @constructor
 */
const DatePicker = ({className,onChange,handleBlur,value,name,title}) => {
	let today = new Date();
	let dd = today.getDate();
	let mm = today.getMonth() + 1;
	const yyyy = today.getFullYear();

	if (dd < 10) {
    	dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today =  yyyy + '-' + mm + '-' + dd;

	const minDate = "1900-01-01";

	return(
		<input
			className={className}
			max={today}
			min={minDate}
			onChange={onChange}
			onBlur={handleBlur}
			value={value}
			name={name}
			type="date"
			title={title}
		/>
	)
}

export default DatePicker

